import moment from "moment";
import { getProfitabilitySummaryCards } from "@/api/financialReport";

// Módulo dedicado al endpoint de summary cards de Rentabilidad. La tabla del
// tab consume desde `financialReports` (tableRowHeaders del estado de
// resultados) — separar el summary acá evita que el ciclo de carga de las
// cards bloquee el render de la tabla y viceversa.

const state = {
    summaryCards: null,
    isSummaryLoading: false,
    summaryError: null,
};

const mutations = {
    SET_SUMMARY_CARDS(state, summary) { state.summaryCards = summary; },
    SET_SUMMARY_LOADING(state, isLoading) { state.isSummaryLoading = isLoading; },
    SET_SUMMARY_ERROR(state, error) { state.summaryError = error; },
};

const actions = {
    async fetchProfitabilitySummary({ commit, rootState }) {
        commit("SET_SUMMARY_LOADING", true);
        commit("SET_SUMMARY_ERROR", null);

        try {
            const endDate = moment(rootState.reportsFilters.endMonth)
                .endOf("month")
                .format("YYYY-MM-DD");

            const response = await getProfitabilitySummaryCards(endDate);
            commit("SET_SUMMARY_CARDS", Object.freeze(response.data));
        } catch (error) {
            console.error("[profitabilityReport] Error fetching summary cards:", error);
            commit(
                "SET_SUMMARY_ERROR",
                error?.response?.data?.detail ?? "Error al cargar resumen de rentabilidad."
            );
        } finally {
            commit("SET_SUMMARY_LOADING", false);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
